export const HOTJAR_SITE_ID = 3714889;
export const HOTJAR_VERSION = 6;
